module.exports = __webpack_public_path__ + "img/active-1.d375fa80.svg";